import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  MiniStressTypeCSVDownloadResponse,
  ActionType,
  IMiniStressTypeDownloadCsvData,
} from "models/stressCheck/miniStressTypeDownloadCsv";
import { httpStatus } from "configs/httpStatus";
import { downloadMiniStressCsvRequest } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./miniStressDownloadCsvActions";

function* miniStressCsvDownloadSaga({
  payload,
}: {
  payload: IMiniStressTypeDownloadCsvData;
}) {
  try {
    const response: MiniStressTypeCSVDownloadResponse = yield call(
      downloadMiniStressCsvRequest,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDownloadMiniStressCSVWatcher() {
  yield takeLatest(
    ActionType.MINI_STRESS_TYPE_DOWNLOAD_CSV as any,
    miniStressCsvDownloadSaga
  );
}

export default [fork(onDownloadMiniStressCSVWatcher)];
